import React, { useState, useEffect } from 'react'
import './popup-notification.scss'
import { siteUrl } from "../../../utils/siteUrl";

const PopupNotification = props => {
    const { notificationState, setnotificationState } = props;

    const [showingBox, setshowingBox] = useState(false)

    var homeLink = siteUrl

    useEffect(() => {
        setshowingBox(true)

        setTimeout(() => {
            setshowingBox(false)
            setTimeout(() => {
                setnotificationState(null)
            }, 500);
        }, 5000);
    }, [])

    return (
        <a href={homeLink + notificationState.slug} className={"f-notification-popup " + (showingBox ? 'showing-popup' : '')}>
            <div className="f-notification-icon-container">
                <img
                    src={notificationState.icon}
                    className="f-notification-icon"
                    alt='Imagen de notificación'
                />
            </div>
            <div className="f-notification-info-container">
                <span className="f-notification-title">
                    {notificationState.tag}
                    {notificationState.verify && <span class="icon-check-2 f-icon"></span>}
                    <span className="f-notification-description">
                        {notificationState.notificationDetail}
                    </span>
                </span>
                <span className="f-notification-time">
                    Ahora
                </span>
            </div>
        </a>
    )
}

export default PopupNotification
